import React, {useEffect, useState} from "react"
import { PageHeader } from '@ant-design/pro-layout';
import PDFComponent from "../../components/PDFComponent";
// import { useAuth } from "../../context/AuthContext";
import { useParams } from "react-router-dom";
import config from "../../business/config.json"
import {useAxios} from "../../hooks/hooks";

function ReportPage(props) {
  const { id,  } = useParams();
  const axios = useAxios();
    const [reportType, setReportType] = useState(null);

  // TODO: should be dependent on company's report type

useEffect(async()=>{
    try {

        const response = await axios.current.get("/customer-projects/" + id);
        console.log(response);
        setReportType(response.data[0].short_name_category);
        console.log(reportType);
    }catch(e){console.log(e);
        setReportType("hmsrc");
    }
}, [id])
  return (

    <>
      <PageHeader
        title={
          <>
            <span>Report</span>&nbsp;
          </>
        }
        style={{ padding: 0, paddingBottom: 16 }}
        extra={[]}
      />
        {reportType === null?  null : <PDFComponent
        file={
          "/business/database/project/latex/" +
            reportType+
          "/" +
          (props.id || id) +
          "/document.pdf"
        }
      />}
    </>
  );
}

export default ReportPage;
